var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnattempted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 30 30",
    fill: "#DCC572",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1651 24.3054C31.2487 18.1184 30.3429 8.97128 24.1671 3.89688C17.9801 -1.18673 8.83301 -0.28092 3.75861 5.89488C-1.325 12.0819 -0.419187 21.229 5.75661 26.3034C11.9436 31.387 21.0907 30.4812 26.1651 24.3054ZM23.3643 22.0041C19.5591 26.6352 12.6989 27.3159 8.05793 23.5026C3.42678 19.6974 2.74615 12.8371 6.55943 8.19619C10.3647 3.56505 17.2249 2.88441 21.8658 6.69769C26.497 10.5029 27.1776 17.3631 23.3643 22.0041ZM7.96751 13L7.96751 17L22 17L22 13L7.96751 13Z",
    fill: "#DCC572"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnattempted);
export default __webpack_public_path__ + "static/media/unattempted.e42db12dd703f9a078392093b91d9fdf.svg";
export { ForwardRef as ReactComponent };